import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

import './styles/index.css';
import { RouterProvider } from 'react-router-dom';
import { isApp, isWctAdmin } from '@util/env';
import appRoutes from '@routes/app-routes';
import adminRoutes from '@routes/admin-routes';
import wctAppRoutes from '@routes/wct-admin-routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider
      router={isApp ? appRoutes : isWctAdmin ? wctAppRoutes : adminRoutes}
    />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
